import classNames from "classnames";
import PropTypes from "prop-types";

export const Normal = ({ children, classes }) => {
  return <p className={classNames(classes, "normal")}>{children}</p>;
};

Normal.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string,
};
